(function () {
  const root = document.getElementById('NewsletterPopup');
  if (!root) return;

  const COOKIE_MAX_AGE = 365 * 24 * 60 * 60;
  const SHOW_DELAY_MS = 1200;
  const CONSENT_STORAGE_KEY = 'milk_cookie_consent_v1';

  function getShopOrigin() {
    return root.getAttribute('data-shop-origin') || window.shopUrl || window.location.origin;
  }

  function getCookieName() {
    const slug = getShopOrigin()
      .toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    return 'milk_newsletter_seen_' + (slug || 'store');
  }

  function readCookie(name) {
    try {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) {
      return null;
    }
  }

  function writeCookie(name, value) {
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  }

  function markSeen(reason) {
    writeCookie(getCookieName(), JSON.stringify({ seen: true, reason: reason, at: Date.now(), origin: getShopOrigin() }));
  }

  function hasSeenForStore() {
    const value = readCookie(getCookieName());
    if (!value) return false;

    try {
      const parsed = JSON.parse(value);
      return parsed.origin === getShopOrigin() || parsed.seen === true;
    } catch (_) {
      return value === '1' || value === 'true';
    }
  }

  function hasCookieConsent() {
    try {
      if (localStorage.getItem(CONSENT_STORAGE_KEY)) return true;
    } catch (_) {}

    return !!readCookie('milk_cookie_consent');
  }

  function isCookieNoticeOpen() {
    const notice = document.getElementById('CookieNotice');
    return notice && !notice.hidden;
  }

  function show() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-visible');
    });
  }

  function hide(markAsSeen) {
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      root.hidden = true;
    }, 320);

    if (markAsSeen) markSeen('dismissed');
  }

  function scheduleShow() {
    if (hasSeenForStore()) return;
    if (root.getAttribute('data-subscribed') === 'true') {
      markSeen('subscribed');
      return;
    }

    window.setTimeout(function () {
      if (hasSeenForStore() || isCookieNoticeOpen()) return;
      show();
    }, SHOW_DELAY_MS);
  }

  function waitForConsentThenShow() {
    if (hasCookieConsent()) {
      scheduleShow();
      return;
    }

    const onConsent = function () {
      scheduleShow();
    };

    document.addEventListener('milk:cookie-consent', onConsent, { once: true });

    const notice = document.getElementById('CookieNotice');
    if (!notice) scheduleShow();
  }

  root.addEventListener('click', function (event) {
    const actionEl = event.target.closest('[data-newsletter-action]');
    if (!actionEl) return;
    if (actionEl.getAttribute('data-newsletter-action') === 'close') hide(true);
  });

  if (root.querySelector('.newsletter-popup__message--error')) {
    show();
    return;
  }

  if (root.getAttribute('data-subscribed') === 'true') {
    markSeen('subscribed');
    return;
  }

  if (hasSeenForStore()) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConsentThenShow);
  } else {
    waitForConsentThenShow();
  }

  window.MilkNewsletterPopup = {
    show: show,
    hide: hide,
    resetForStore: function () {
      writeCookie(getCookieName(), '');
      show();
    },
  };
})();
